import React, { Suspense } from 'react';
import { WrapperWidget } from '@agentselly/ui';
import { useTranslate } from '@tolgee/react';

const LineChart = React.lazy(() =>
  import('~/components/charts/LineChart').then((module) => ({
    default: module.LineChart,
  })),
);

interface Props {
  readonly title: string;
  readonly infoText?: string;
  readonly data?: {
    readonly date: string;
    readonly offerPrice: string;
  }[];
}

export function CockpitOffersTrendWidget(props: Props) {
  const { t } = useTranslate();
  const toNumber = (s: string) => {
    const clean = String(s).replace(/[^0-9.]/g, '');
    console.log('Parsing price:', s, '->', clean); // Debug log
    const n = parseFloat(clean);
    console.log('Parsed number:', n); // Verify parsing
    return Number.isFinite(n) ? n : 0;
  };
  const series = [...(props.data || [])]
    .map((item) => {
      console.log('Raw data point:', item); // Debug raw props.data
      return {
        x: item.date,
        y: toNumber(item.offerPrice),
      };
    })
    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

  console.log('Final series for chart:', series); // Debug final series

  return (
    <WrapperWidget
      title={t(props.title)}
      text={
        props.infoText ? t(props.infoText as any) || props.infoText : undefined
      }
    >
      <div className="w-full">
        {series?.length ? (
          <div className="rounded-lg border border-slate-200 dark:border-slate-700 dark:border-gray-700 bg-white dark:bg-gray-800 p-4">
            <Suspense
              fallback={
                <div className="h-32 animate-pulse bg-slate-100 rounded" />
              }
            >
              <LineChart
                datasetIdKey={'offers-trend'}
                series={series as any}
                yFormat="currency"
              />
            </Suspense>
          </div>
        ) : (
          <div className="text-center py-8 text-slate-500 dark:text-slate-400">
            {t('cockpit_offers_trend_empty') || t('cockpit_offers_trend_empty')}
          </div>
        )}
      </div>
    </WrapperWidget>
  );
}
